import { defineMessages } from 'react-intl'

export default defineMessages({
    "accountStatus": {
        "defaultMessage": "Account Status: {status}",
        "id": "src.HomePage.ProfileFormPanel.accountStatus.header"
    },
    "activeStatus": {
        "defaultMessage": "Active",
        "id": "src.HomePage.ProfileFormPanel.activeStatus.header"
    },
    "add": {
        "defaultMessage": "ADD",
        "id": "src.HomePage.ProfileFormPanel.add.button"
    },
    "addAdmin": {
        "defaultMessage": "Add Admin",
        "id": "src.HomePage.ProfileFormPanel.addAdmin.header"
    },
    "addRider": {
        "defaultMessage": "Add Rider",
        "id": "src.HomePage.ProfileFormPanel.addRider.header"
    },
    "addUser": {
        "defaultMessage": "Add User",
        "id": "src.HomePage.ProfileFormPanel.addUser.header"
    },
    "editAdmin": {
        "defaultMessage": "Edit Admin",
        "id": "src.HomePage.ProfileFormPanel.editAdmin.header"
    },
    "editRider": {
        "defaultMessage": "Edit Rider",
        "id": "src.HomePage.ProfileFormPanel.editRider.header"
    },
    "editUser": {
        "defaultMessage": "Edit User",
        "id": "src.HomePage.ProfileFormPanel.editUser.header"
    },
    "email": {
        "defaultMessage": "Email",
        "id": "src.HomePage.ProfileFormPanel.addAdmin.email.placeholder"
    },
    "firstName": {
        "defaultMessage": "First Name",
        "id": "src.HomePage.ProfileFormPanel.addAdmin.firstName.placeholder"
    },
    "inactiveStatus": {
        "defaultMessage": "Inactive",
        "id": "src.HomePage.ProfileFormPanel.inactiveStatus.header"
    },
    "invited": {
        "defaultMessage": "Invited",
        "id": "src.HomePage.ProfileFormPanel.invited.header"
    },
    "lastName": {
        "defaultMessage": "Last Name",
        "id": "src.HomePage.ProfileFormPanel.addAdmin.lastName.placeholder"
    },
    "na": {
        "defaultMessage": "N/A",
        "id": "src.HomePage.ProfileFormPanel.na"
    },
    "password": {
        "defaultMessage": "Password",
        "id": "src.HomePage.ProfileFormPanel.addAdmin.password.placeholder"
    },
    "phoneNumber": {
        "defaultMessage": "Phone Number",
        "id": "src.HomePage.ProfileFormPanel.addRider.phoneNumber.overline"
    },
    "resendCode": {
        "defaultMessage": "Resend Code",
        "id": "src.HomePage.ProfileFormPanel.inviteUser.resendCode.button"
    },
    "resendCodeSent": {
        "defaultMessage": "Resend Code Sent Successfully",
        "id": "src.HomePage.ProfileFormPanel.inviteUser.resendCodeSent.alert"
    },
    "save": {
        "defaultMessage": "SAVE",
        "id": "src.HomePage.ProfileFormPanel.editInfo.save.button"
    },
    "userGroups": {
        "defaultMessage": "User is part of the following groups:",
        "id": "src.HomePage.ProfileFormPanel.editInfo.userGroups.header"
    },
    "rfid": {
        "defaultMessage": "RFID",
        "id": "src.HomePage.ProfileFormPanel.addAdmin.rfid.placeholder"
    }
})

